<template>
  <div> 
    <div class="main">
      <div class="heard">
        绑定手机号
      </div>
      <div class="conter">
        <el-form :label-position="labelPosition" status-icon :rules="rules" label-width="106px" :model="modification">
          <!-- <el-form-item label="旧手机号码：" prop="oldphone">
            <el-input v-model="modification.oldphone" disabled=""></el-input>
          </el-form-item> -->
          <el-form-item label="手机号码：" prop="newphone">
            <el-input v-model="modification.newphone" placeholder="请输入新手机号"  size="small"></el-input>
            <div class="formrightbox formrightboxb">
            </div>
          </el-form-item>
          <el-form-item label="验证码：" prop="code">
            <el-input v-model="modification.code" placeholder="请输入验证码" style="width:50%;float:left;"  size="small"></el-input>
            <el-button type="primary" class="" @click="sendCode()" :disabled="isDisabled" style="float: left;margin-left:20px">{{buttonName}}</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" class="btn" @click="bindPhone()" style="font-size:20px">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../static/config.json";
import Bus from "@/assets/js/bus";
export default {
  name: "phone",
  data() {
    var reg = /^1[23456789]\d{9}$/;
    var validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电话号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
        this.codephone = true;
      }
    };
    return {
      labelPosition: "right",
      buttonName: "发送短信验证码",
      isDisabled: false,
      time: 60,
      codephone: false,
      modification: {
        oldphone: "",
        newphone: "",
        code: ""
      },
      rules: {
        newphone: [
          { required: true, trigger: "blur", validator: validPhone } //这里需要用到全局变量
        ]
      }
    };
  },
  mounted() {},
  methods: {
    // 发送验证码
    sendCode() {
      if (this.codephone == true) {
        let postData = "phone=" + this.modification.newphone;
        let url = "login/SendVerifyCodeToPhone/" + this.$store.state.inscode;
        this.$api.post(url, postData, response => {
          if (response.Ret == 0) {
            this.$message.success("短信验证码已发送，请注意查收");
            this.sendMsg();
          } else {
            this.$alert(response.Msg);
          }
        });
      } else {
        this.$message.error("手机号输入有误!");
      }
    },
    //绑定手机号
    bindPhone() {
      if (this.modification.code == "") {
        this.$message.error("验证码不能为空");
        return;
      }
      this.loading = true;
      let url = "/Account/BindPhone";
      let postData = {
        Phone: this.modification.newphone,
        Code: this.modification.code
      };
      this.$loginapi.post(url, postData, response => {
        this.loading = false;
        if (response.Ret == 0) {
          this.$message.success("手机号码绑定成功!");
          this.$router.push("/personaldata");
          Bus.$emit("activeIndex4", "/personaldata");
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 短信验证倒计时
    sendMsg() {
      let me = this;
      me.isDisabled = true;
      let interval = window.setInterval(function() {
        me.buttonName = "（" + me.time + "s）重新发送";
        --me.time;
        if (me.time < 0) {
          me.buttonName = "发送短信验证码";
          me.time = 60;
          me.isDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modification/phone.vue